import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=9bc80cec&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=ts&"
export * from "./Banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc80cec",
  null
  
)

component.options.__file = "Banner.vue"
export default component.exports